import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[capDynamicDialogContent]'
})
export class DynamicDialogcontentDirective {

  constructor(public viewContainerRef: ViewContainerRef) {}

}
